export default "__VITE_ASSET__Cbz1hh43__"